/* eslint-disable */
import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";
import Multiselect from "@vueform/multiselect";

export default {
    name: "ManageMitigationTaskModal",
    components: { customModal, Multiselect },

    props: {
        studyId: String,
        ctqId: String,
        mitigationId: String,
        mitigationCode: String,
        taskItem: {
            type: Object,
            default: null,
        },
    },

    emits: ["closeModal", "taskSaved"],

    computed: {
        isEditMode() {
            return !!this.taskItem;
        },
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            saving: false,
            roleList: [],
            form: {
                taskId: "",
                taskDescription: "",
                owner: "",
                cadence: "",
            },
            errors: {},
        };
    },

    mounted() {
        this.token = store.getters.getIdToken;
        this.setRoleList().then(() => {
            if (this.taskItem) {
                const assignedRoleValue = this.taskItem.assignedRole || this.taskItem.owner;
                const matchedRole = this.roleList.find(r => r.roleName === assignedRoleValue);
                this.form = {
                    taskId: this.taskItem.taskId || "",
                    taskDescription: this.taskItem.taskDescription || "",
                    owner: matchedRole ? matchedRole.roleID : assignedRoleValue || "",
                    cadence: this.taskItem.cadence || "",
                };
            }
        });
    },

    methods: {
        async setRoleList() {
            try {
                const response = await axios.get(
                    `${this.baseurl}/account-core/roles/rolelist`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.roleList = response.data || [];
            } catch (error) {
                console.error(error);
            }
        },

        validate() {
            this.errors = {};
            if (!this.form.taskId.trim()) this.errors.taskId = "Task ID is required.";
            return Object.keys(this.errors).length === 0;
        },

        async save() {
            if (!this.validate()) return;
            this.saving = true;

            var payload = {
                taskId: this.form.taskId.trim(),
                taskDescription: this.form.taskDescription.trim(),
                assignedRole: this.roleList.find(r => r.roleID === this.form.owner)?.roleName || this.form.owner,
                cadence: this.form.cadence,
            };

            try {
                if (this.isEditMode) {
                    await axios.put(
                        this.baseurl + `/forms/ctq/updatemitigationtask/${this.mitigationId}`,
                        payload,
                        {
                            headers: {
                                Authorization: "Bearer " + this.token,
                                "Content-Type": "application/json",
                            },
                        }
                    );
                } else {
                    await axios.post(
                        this.baseurl + `/forms/ctq/createmitigationtask?id=${this.mitigationId}`,
                        payload,
                        {
                            headers: {
                                Authorization: "Bearer " + this.token,
                                "Content-Type": "application/json",
                            },
                        }
                    );
                }
                this.$emit("taskSaved");
                this.closeModal();
            } catch (error) {
                console.error("Error saving task:", error);
                this.errors.taskId = error?.response?.data?.message || "Failed to save task. Please try again.";
            } finally {
                this.saving = false;
            }
        },

        closeModal() {
            this.$emit("closeModal");
        },

        clearForm() {
            this.form = {
                taskId: "",
                taskDescription: "",
                owner: "",
                cadence: "",
            };
            this.errors = {};
        },
    },
};